/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Typography, FormControl } from '@mui/material';
import get from "lodash/get";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

const DateTimePickerUi = ({ formik, name, label, disabled, labelInput = null, ...props }) => {
    const [value, setValue] = useState(null);

    const onChange = (e) => {
        setValue(e);
        formik.setFieldValue([name], e.format());  // Retorna la fecha y hora en formato ISO
    };

    useEffect(() => {
        const initialValue = get(formik, `values.[${name}]`);
        if (initialValue) {
            setValue(dayjs(initialValue));  // Inicializa el valor si ya existe en el formik
        }
    }, []);

    return (
        <FormControl fullWidth>
            {!labelInput && (
                <Typography className='pb-2 pl-4' component="label" htmlFor={name} color={disabled ? "text.lite" : "text.main"}>
                    {label}
                </Typography>
            )}
            <DateTimePicker
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                disabled={disabled}
                {...props}
                {...(labelInput ? { label } : {})}
            />
        </FormControl>
    );
};

export default DateTimePickerUi;
